import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import { connect } from 'react-redux';
import { hideUndeliverableModal } from '../../actions/locationActions';
import UndeliverableModal from '../../components/UndeliverableModal';
import i18n from '../../utils/i18n';

export function UndeliverableContainer({
  isOpen,
  onClose,
  isPostcodeSearch,
  brandName,
  postcode,
  geohash,
}) {
  // TODO: for international Brand Landing Pages launch, we need to translate a
  // geohash to a place name using the locationFromGeolocation action.
  const location = isPostcodeSearch ? postcode : geohash;

  return (
    <UndeliverableModal
      isOpen={isOpen}
      onClose={onClose}
      closeButtonLabel={i18n.gettext('closeButton.label')}
      actionButtonLabel={i18n.gettext('landingPage.brand.undeliverableModal.actionButtonLabel')}
      heading={i18n.gettext(
        'landingPage.brand.undeliverableModal.heading(%(brandName)s, %(location)s)',
        { brandName, location },
      )}
      body={i18n.gettext('landingPage.brand.undeliverableModal.body(%(brandName)s)', { brandName })}
    />
  );
}

UndeliverableContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isPostcodeSearch: PropTypes.bool.isRequired,
  brandName: PropTypes.string.isRequired,
  postcode: isRequiredIf(PropTypes.string, ({ isPostcodeSearch }) => isPostcodeSearch === true),
  geohash: isRequiredIf(PropTypes.string, ({ isPostcodeSearch }) => isPostcodeSearch === false),
};

UndeliverableContainer.defaultProps = {
  postcode: undefined,
  geohash: undefined,
};

const mapStateToProps = (state) => {
  const { postcodeSearch: isPostcodeSearch } = state.request.country;
  const { showUndeliverableModal, query } = state.location.search;
  const { postcode, geohash } = query || {};

  return {
    isOpen: Boolean(showUndeliverableModal),
    isPostcodeSearch,
    postcode,
    geohash,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(hideUndeliverableModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UndeliverableContainer);
